import { Fragment, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import Menu from "../menu/Menu";
import InfoVision from "../home/InfoVision";
const Footer = lazy(() => import('../footer/Footer'));
function Vision() {
  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="Hyundai Motor Company se esfuerza por proporcionar libertad de movimiento a todos invirtiendo en servicios de movilidad."
        />
        <meta name="keywords" content="Hyundai, visión, futuro, movilidad" />
        <title>Hyundai visión futuro</title>
      </Helmet>
      <Menu />
      <InfoVision />
      <Suspense fallback={<div>Cargando footer...</div>}>
        <Footer />
      </Suspense>
    </Fragment>
  );
}
export default Vision;